export const environment = {
  production: true,
  apiUrl: 'https://acba.am',
  allowedHosts: ['acba.am', 'www.acba.am', 'localhost'],
  origin: 'https://acba.am',
  acquiringRouteId: 12573,
  sustainableDevelopmentRouteId: 12771,
  packagesRouteId: 12979,
};
